import { render, staticRenderFns } from "./about.vue?vue&type=template&id=a9b5401c&scoped=true&"
import script from "./about.vue?vue&type=script&scoped=true&lang=js&"
export * from "./about.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./about.vue?vue&type=style&index=0&id=a9b5401c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5401c",
  null
  
)

export default component.exports